import * as React from 'react';
import { cn } from '@/lib/utils';

export interface KpiValueProps extends React.HTMLAttributes<HTMLSpanElement> {
  accent?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'text-sm font-semibold tabular-nums',
  md: 'text-base font-bold tabular-nums',
  lg: 'text-lg font-bold tabular-nums tracking-tight',
};

export const KpiValue = React.forwardRef<HTMLSpanElement, KpiValueProps>(
  ({ accent = false, size = 'md', className, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          sizeClasses[size],
          accent
            ? 'text-primary'
            : 'text-foreground',
          className
        )}
        {...props}
      />
    );
  }
);
KpiValue.displayName = 'KpiValue';
